import React, { useState, useRef, useEffect } from 'react'
import { selectModal, setModal } from "../../redux/modalSlice";
import { useDispatch, useSelector } from 'react-redux'
import { selectPortfolios } from '../../redux/portfolioSlice';

export default function PreviewTemplateModal() {
  const modal = useSelector(selectModal)
  const dispatch = useDispatch();
  const templateName = modal.options?.templateName
  const templateBody = modal.options?.templateBody
  const record = modal.options?.record
  const handleCancel = () => {
    dispatch(setModal({ is_active: false }));
  };
  const portfolios = useSelector(selectPortfolios);

  const templatePlaceholders = () => {
    if (record.portfolio_id) {
      const portfolio = portfolios.data.find((x) => x.id === record.portfolio_id)
      return templateBody.replaceAll('{{$template_placeholder_aws_bucket_name}}', portfolio.aws_bucket_name).replaceAll('{{$template_placeholder_app_url}}', portfolio.app_url)
    }
    return templateBody
  }

  return modal.is_active && modal.type === 'preview_template' ? (
    <div className="modal is-active is-large">
      <div className="modal-background"></div>
      <div className="modal-card column is-9">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">
            Template: {templateName}
          </p>
          <button className="delete" aria-label="close" onClick={handleCancel}></button>
        </header>
        <section className="modal-card-body lox-footer-modal-card-body pt-1 pb-1">
          <iframe title="template" srcDoc={templatePlaceholders()} style={{ display: 'block', width: '100%', height: '70vh' }} />
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button
              type="button"
              onClick={handleCancel}
              className="button is-small has-background-grey has-text-white"
            >
              Cancel
            </button>
          </div>
        </footer>
      </div>
    </div>
  ) : ''
}
